import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Flex, Text } from "@chakra-ui/react";
import Select from "react-select";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import ActiveSubscriptionsTable from "../../../containers/admin/asquera-practice/active-subscriptions-table";
import {
  getActiveSubscriptionsRequest,
  getPracticeSubjectsRequest,
} from "../../../modules/admin-modules/asquera-practice/Actions";

const colourStyles = {
  control: (styles) => ({
    ...styles,
    width: "100%",
    background: "#f5f5f5",
    color: "#690000",
    borderRadius: "16px",
  }),
  option: (styles) => ({ ...styles, color: "#690000" }),
};

const AsqueraPracticeActiveSubscriptions = () => {
  const dispatch = useDispatch();
  const subjects = useSelector((state) => state.asqueraPractice.subjects);
  const [subjectId, setSubjectId] = useState(null);

  useEffect(() => {
    dispatch(getPracticeSubjectsRequest());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getActiveSubscriptionsRequest(subjectId));
  }, [dispatch, subjectId]);

  const subjectOptions = [
    { value: null, label: "كل المواد" },
    ...(Array.isArray(subjects)
      ? subjects.map((subject) => ({
          value: subject.id,
          label: subject.name || subject.title,
        }))
      : []),
  ];

  return (
    <Layout>
      <Box w="100%" p={4}>
        <Flex
          w="100%"
          my="30px"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap={3}
        >
          <Text fontSize="24px" fontWeight="600" color="main_1">
            الاشتراكات النشطة - Asquera Practice
          </Text>
          <LogoutMenu />
        </Flex>

        <Box w={{ base: "100%", md: "40%" }} mb={6}>
          <Text fontSize="16px" fontWeight="500" color="main_1" mb="10px">
            تصفية حسب المادة
          </Text>
          <Select
            options={subjectOptions}
            styles={colourStyles}
            placeholder="كل المواد"
            value={
              subjectOptions.find((option) => option.value === subjectId) ||
              subjectOptions[0]
            }
            onChange={(option) => setSubjectId(option?.value || null)}
          />
        </Box>

        <ActiveSubscriptionsTable key={subjectId || "all"} />
      </Box>
    </Layout>
  );
};

export default AsqueraPracticeActiveSubscriptions;
